"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateButtonTestId = exports.BackButtonTestId = exports.DialogTestId = exports.SelectionButtonTestId = exports.CancelButtonTestId = exports.ActivitySpinnerTestId = exports.PasswordTestId = exports.UsernameTestId = exports.UsernameAndPasswordId = exports.PortTestId = exports.HostnameTestId = exports.ConnectionNameTestId = exports.RequireSSLTestId = void 0;
exports.RequireSSLTestId = 'require-ssl-checkbox-test-id';
exports.ConnectionNameTestId = 'connection-name-test-id';
exports.HostnameTestId = 'host-name-test-id';
exports.PortTestId = 'port-test-id';
exports.UsernameAndPasswordId = 'username-and-password-test-id';
exports.UsernameTestId = 'username-test-id';
exports.PasswordTestId = 'password-test-id';
exports.ActivitySpinnerTestId = 'activity-spinner-test-id';
exports.CancelButtonTestId = 'cancel-button-test-id';
exports.SelectionButtonTestId = 'selection-button-test-id';
exports.DialogTestId = 'analytics-extensions-settings-dialog-id';
exports.BackButtonTestId = 'back-button-test-id';
exports.CreateButtonTestId = 'create-button-test-id';
//# sourceMappingURL=TestIds.js.map